export default __webpack_public_path__ + "static/media/profile-2.9c96bf40.png";